import {
  Component,
  HostListener,
  AfterViewInit,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core';

const ALT_KEY = 18;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'calendar';

  @ViewChild('timeaxis', { static: false }) timeAxis: ElementRef;
  @ViewChild('vp', { static: false }) viewportEl: ElementRef;

  routes = [
    {
      id: 'abcdefg',
      start: '07:00',
      end: '11:00'
    },
    {
      id: 'qrs',
      start: '06:30',
      end: '08:30'
    },
    {
      id: 'hijklmnop',
      start: '06:15',
      end: '08:00'
    },
    {
      id: 'tuv',
      start: '08:30',
      end: '12:00'
    }
  ];

  calendarConfig = {
    dayStart: '06:00',
    dayEnd: '18:00',
    intervalWidth: 50,
    xAxisHeight: 100,
    minutesPerInterval: 15,
    assets: [
      {
        name: 'Boom Truck',
        color: '#f08080'
      },
      {
        name: 'Flatbed',
        color: '#1e90ff'
      },
      {
        name: 'Box Truck',
        color: '#64e986'
      }
    ]
  };

  viewport = {
    width: this.calculateDayPixelWidth(),
    rows: [] // array of objects
  };

  dragState = {
    cardViewportStartPxCoords: null,
    cardInternalMouseOffset: null,
    last: null,
    originalMouseAbsolutePosition: null
  };

  dragging = null;
  altDown = false;

  viewportDragState = {
    initialScroll: null,
    originalMouseAbsolutePosition: null,
    last: null
  };

  private getRoute(id) {
    return this.routes.find(r => r.id === id);
  }

  ngOnInit() {
    // Initialize sample data
    this.routes.forEach(r => this.initRoute(r));

    for (let i = 0; i < 3; i++) {
      const { name, color } = this.calendarConfig.assets[i];

      const cells = Array(this.calculateDayTotalIntervals()).fill(0);
      console.log(cells);

      this.viewport.rows.push({
        name,
        color,
        cards: [],
        cells
      });
    }

    // Link sample data
    const boomtruckRow = this.viewport.rows[0];
    boomtruckRow.cards.push(this.getRoute('abcdefg'));
    boomtruckRow.cards[0].rowColor = this.calendarConfig.assets[0].color;

    const flatbedRow = this.viewport.rows[1];
    flatbedRow.cards.push(this.getRoute('qrs'));
    flatbedRow.cards[0].rowColor = this.calendarConfig.assets[1].color;

    flatbedRow.cards.push(this.getRoute('tuv'));
    flatbedRow.cards[1].rowColor = this.calendarConfig.assets[1].color;

    const boxtruckRow = this.viewport.rows[2];
    boxtruckRow.cards.push(this.getRoute('hijklmnop'));
    boxtruckRow.cards[0].rowColor = this.calendarConfig.assets[2].color;
  }
  ngAfterViewInit() {
    // console.log('viewchild', this.route1El);
    // this.sampleRoute.element = this.route1El;
  }

  initRoute(route) {
    const offset = this.calculateIntervalsFromDayStartTime(route.start);
    document.documentElement.style.setProperty(
      `--${route.id}-interval-offset`,
      `${offset}`
    );

    // get total intervals of this route
    const width = this.calculateIntervalsBetweenTwoTimes(
      route.start,
      route.end
    );
    document.documentElement.style.setProperty(
      `--${route.id}-interval-width`,
      `${width}`
    );
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event) {
    if (event.keyCode === ALT_KEY && this.altDown) {
      this.altDown = false;
    }
    event.preventDefault();
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event) {
    if (event.keyCode === ALT_KEY && !this.altDown) {
      this.altDown = true;
    }
    event.preventDefault();
  }

  @HostListener('window:wheel', ['$event'])
  onWheelScroll(event) {
    if (!this.altDown) {
      return;
    }
    // TODO: Figure out how to disable browser zoom
    // https://stackoverflow.com/a/17864991
    if (event.deltaY < 0) {
      const newZoom = this.calendarConfig.intervalWidth + 2;
      if (newZoom > 100) {
        // sane default
        return;
      }

      this.intervalChanged(newZoom);
    } else if (event.deltaY > 0) {
      const newZoom = this.calendarConfig.intervalWidth - 2;
      if (newZoom < 30) {
        return;
      }
      this.intervalChanged(newZoom);
    }
  }

  intervalChanged(interval) {
    let value = interval;
    if (interval.target) {
      value = parseInt(interval.target.value, 10);
    }

    this.calendarConfig.intervalWidth = value;
    document.documentElement.style.setProperty(
      '--interval-width',
      `${value}px`
    );
  }

  xAxisHeightChanged(height) {
    let value = 100;
    if (height.target) {
      value = parseInt(height.target.value, 10);
    }

    this.calendarConfig.xAxisHeight = value;
    document.documentElement.style.setProperty('--x-axis-height', `${value}px`);
  }

  isDragging(id) {
    return this.dragging === id;
  }

  routeStartChanged({ id, time }) {
    let startTime = time;
    if (time.target) {
      startTime = time.target.value;
    }

    const offset = this.calculateIntervalsFromDayStartTime(startTime);

    if (offset < 0) {
      // prevent from starting before the day starts.
      // todo: also handle day end
      return;
    }

    // set start on the correct route
    const route = this.routes.find(r => r.id === id);
    route.start = startTime;

    // update the route's offset for start
    document.documentElement.style.setProperty(
      `--${id}-interval-offset`,
      `${offset}`
    );
  }

  routeEndChanged({ id, time }) {
    let end = time;
    if (time.target) {
      end = time.target.value;
    }

    const route = this.routes.find(r => r.id === id);

    const width = this.calculateIntervalsBetweenTwoTimes(route.start, end);

    // Ensure end is after start
    if (this.stringToMinutes(end) <= this.stringToMinutes(route.start)) {
      return;
    }

    // Ensure endCell - width > 0
    const endCell = this.calculateIntervalsFromDayStartTime(end);

    if (endCell - width < 0) {
      return;
    }

    route.end = end;
    document.documentElement.style.setProperty(
      `--${route.id}-interval-width`,
      `${width}`
    );
  }

  cardDragStart({ event, id }) {
    const clone = event.target.cloneNode(true);
    clone.style.display = 'none';
    event.dataTransfer.setDragImage(clone, 0, 0);

    this.dragState.cardViewportStartPxCoords = {
      x: event.target.offsetLeft,
      y: event.target.offsetTop
    };

    this.dragState.cardInternalMouseOffset = {
      x: event.offsetX,
      y: event.offsetY
    };

    this.dragState.originalMouseAbsolutePosition = {
      x: event.pageX,
      y: event.pageY
    };

    // const startCell = this.calculateStartCellFromOffset(
    //   {
    //     x: this.dragState.origin.x,
    //     y: this.dragState.origin.y
    //   },
    //   { x: 0, y: 0 }
    // );
  }

  cardDragged({ event, id }, omitStart = false, omitEnd = false) {
    this.dragging = id;

    const cardData = this.getCurrentCardData(id);

    event.preventDefault();
    event.stopPropagation();

    const deltaX = this.dragState.originalMouseAbsolutePosition.x - event.pageX;
    const deltaY = this.dragState.originalMouseAbsolutePosition.y - event.pageY;

    const newStartCell = omitStart
      ? cardData.originalStartCell
      : this.calculateStartCellFromViewportOffset(
          this.dragState.cardViewportStartPxCoords,
          {
            x: deltaX,
            y: deltaY
          }
        );

    // Guard against last drag event with weird numbers.
    if (!this.isGoodDrag(newStartCell)) {
      return;
    }

    const newStartTime = this.calculateCellStartTime(
      this.calendarConfig.dayStart,
      newStartCell.x
    );

    // don't move if before day start
    if (newStartCell.x < 0) {
      return;
    }

    const newEndTime = omitEnd
      ? cardData.originalEndTime
      : this.calculateTimePlusIntevals(newStartTime, cardData.width);

    // Ensure new end time is within the day
    if (this.compareTime(newEndTime, this.calendarConfig.dayEnd) === 1) {
      return;
    }

    if (!omitStart) {
      this.routeStartChanged({ id, time: newStartTime });
    }

    this.routeEndChanged({ id, time: newEndTime });
  }

  cardDragEnd({ event, id }) {
    this.dragging = null;
    this.dragState.last = null;
  }

  cellDragOver(event) {
    event.toElement.style.backgroundColor = 'red';
  }

  cellClick(event, x, y) {
    console.log(`${x}, ${y}`);
  }

  cardStartTimeDragStart({ event, id }) {
    const clone = event.target.cloneNode(true);
    clone.style.display = 'none';
    event.dataTransfer.setDragImage(clone, 0, 0);

    const route = this.getRoute(id);
    const cellX = this.calculateIntervalsFromDayStartTime(route.start);

    // this is NOT the cell.
    // this is the mouse x/y position from the viewport
    const xOffsetFromViewport = event.pageX - this.getYAxisWidth();

    this.dragState.cardViewportStartPxCoords = {
      x: xOffsetFromViewport + this.viewportEl.nativeElement.scrollLeft,
      y: 0
    };

    this.dragState.cardInternalMouseOffset = {
      x: event.offsetX,
      y: event.offsetY
    };

    this.dragState.originalMouseAbsolutePosition = {
      x: event.pageX,
      y: event.pageY
    };
  }

  cardStartTimeDragged({ event, id }) {
    event.preventDefault();
    event.stopPropagation();

    // also needs to take into account the viewport scroll
    const deltaX = this.dragState.originalMouseAbsolutePosition.x - event.pageX;
    const deltaY = this.dragState.originalMouseAbsolutePosition.y - event.pageY;

    const newStartCell = this.calculateStartCellFromViewportOffset(
      this.dragState.cardViewportStartPxCoords,
      // origin,
      {
        x: deltaX,
        y: deltaY
      }
    );

    if (!this.isGoodDrag(newStartCell)) {
      return;
    }

    const route = this.getRoute(id);
    const newStartTime = this.cellXToTime(newStartCell.x);

    if (this.stringToMinutes(newStartTime) >= this.stringToMinutes(route.end)) {
      return;
    }

    this.routeStartChanged({ id, time: newStartTime });

    // recalculate the width
    this.routeEndChanged({ id, time: route.end });
  }

  cardEndTimeDragStart({ event, id }) {
    const clone = event.target.cloneNode(true);
    clone.style.display = 'none';
    event.dataTransfer.setDragImage(clone, 0, 0);

    const route = this.getRoute(id);
    const cellX = this.calculateIntervalsFromDayStartTime(route.start);

    // this is NOT the cell.
    // this is the mouse x/y position from the viewport
    const xOffsetFromViewport = event.pageX - this.getYAxisWidth();

    this.dragState.cardViewportStartPxCoords = {
      x: xOffsetFromViewport + this.viewportEl.nativeElement.scrollLeft,
      y: 0
    };

    this.dragState.cardInternalMouseOffset = {
      x: event.offsetX,
      y: event.offsetY
    };

    this.dragState.originalMouseAbsolutePosition = {
      x: event.pageX,
      y: event.pageY
    };
  }
  cardEndTimeDragged({ event, id }) {
    event.preventDefault();
    event.stopPropagation();

    // also needs to take into account the viewport scroll
    const deltaX = this.dragState.originalMouseAbsolutePosition.x - event.pageX;
    const deltaY = this.dragState.originalMouseAbsolutePosition.y - event.pageY;

    // calculate new end cell from deltas
    const newEndCell = this.calculateEndCellFromViewportOffset(
      this.dragState.cardViewportStartPxCoords,
      {
        x: deltaX,
        y: deltaY
      }
    );

    if (!this.isGoodDrag(newEndCell)) {
      return;
    }

    const route = this.getRoute(id);
    const newEndTime = this.cellXToTime(newEndCell.x);

    // End must be > start
    console.log('newEndTime', newEndTime);

    if (this.stringToMinutes(newEndTime) <= this.stringToMinutes(route.start)) {
      return;
    }

    this.routeEndChanged({ id, time: newEndTime });
  }

  getRowWidthStyle() {
    return {
      width: `calc(var(--total-cells) * var(--interval-width))`
    };
  }

  viewportScroll(event) {
    // just to cache last scroll pos
    this.viewportDragState.last = event.target.scrollLeft;
    this.timeAxis.nativeElement.scrollLeft = event.target.scrollLeft;
  }

  viewportDragStart(event) {
    const clone = event.target.cloneNode(true);
    clone.style.display = 'none';
    event.dataTransfer.setDragImage(clone, 0, 0);

    this.viewportDragState.originalMouseAbsolutePosition = {
      x: event.pageX,
      y: event.pageY
    };

    const xScroll = this.viewportEl.nativeElement.scrollLeft;
    const yScroll = this.viewportEl.nativeElement.scrollRight;
    this.viewportDragState.initialScroll = { x: xScroll, y: yScroll };
  }

  viewportDragEnd(event) {
    this.dragState.last = null;
    event.preventDefault();
  }

  viewportDrag(event) {
    event.stopPropagation();
    event.preventDefault();

    if (event.pageX === 0) {
      return;
    }

    const deltaX =
      this.viewportDragState.originalMouseAbsolutePosition.x - event.pageX;

    let newScrollX = this.viewportDragState.initialScroll.x + deltaX;
    if (newScrollX <= 0) {
      newScrollX = 0;
    }

    const contentWidth = event.target.scrollWidth;
    const viewportWidth = event.target.clientWidth;

    // cross multiply to figure out proportion
    const extrapolatedWidth = (viewportWidth * viewportWidth) / contentWidth;
    const multiplier = extrapolatedWidth / viewportWidth;
    const scrollBarWidth = viewportWidth * multiplier;
    const normalizedScrollLeft = event.target.scrollLeft * multiplier;

    const pxToEnd = viewportWidth - normalizedScrollLeft - scrollBarWidth;

    // If we're already at the end and we're attempting to drag further
    if (pxToEnd <= 0 && deltaX > 0) {
      newScrollX = event.target.scrollLeft;
    }

    if (!this.isGoodViewportScroll(newScrollX)) {
      return;
    }

    this.timeAxis.nativeElement.scrollLeft = newScrollX;
    this.viewportEl.nativeElement.scrollLeft = newScrollX;
  }

  private getCurrentCardData(id) {
    // never updated
    const originalStartCell = this.calculateStartCellFromViewportOffset(
      this.dragState.cardViewportStartPxCoords,
      { x: 0, y: 0 }
    );

    const width = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        `--${id}-interval-width`
      ),
      10
    );

    const originalEndCell = {
      x: originalStartCell.x + width,
      y: originalStartCell.y
    };

    const [originalStartTime, originalEndTime] = [
      this.cellXToTime(originalStartCell.x),
      this.cellXToTime(originalEndCell.x)
    ];

    return {
      originalStartCell,
      originalEndCell,
      originalStartTime,
      originalEndTime,
      width
    };
  }

  // Calculates mouse movement
  private calculateStartCellFromViewportOffset(
    origin: { x: number; y: number }, // origin mouse position (pageX, pageY)
    offset: { x: number; y: number } // offset mouse movement (from pageX, pageY)
  ) {
    const intervalsX =
      (origin.x - offset.x) / this.calendarConfig.intervalWidth;
    const intervalsY = (origin.y - offset.y) / 80; // need cell height

    const target = { x: Math.floor(intervalsX), y: Math.floor(intervalsY) };
    return target;
  }

  private calculateEndCellFromViewportOffset(
    // currently duplicate of above method
    origin: { x: number; y: number }, // origin mouse position (pageX, pageY)
    offset: { x: number; y: number } // offset mouse movement (from pageX, pageY)
  ) {
    const intervalsX =
      (origin.x - offset.x) / this.calendarConfig.intervalWidth;
    const intervalsY = (origin.y - offset.y) / 80; // need cell height

    const target = { x: Math.floor(intervalsX), y: Math.floor(intervalsY) };
    return target;
  }

  private calculateCellStartTime(dayStartTime: string, cellX: number): string {
    const dayStartMinutes = this.stringToMinutes(dayStartTime);
    const cellMinuteOffset =
      dayStartMinutes + cellX * this.calendarConfig.minutesPerInterval;

    const offsetString = this.minutesToTime(cellMinuteOffset);
    return offsetString;
  }

  private calculateIntervalsFromDayStartTime(startTime: string): number {
    const dayStartMinutes = this.stringToMinutes(this.calendarConfig.dayStart);
    const routeStartMinutes = this.stringToMinutes(startTime);
    const minutesSinceDayStart = routeStartMinutes - dayStartMinutes;
    const totalIntervals =
      minutesSinceDayStart / this.calendarConfig.minutesPerInterval;

    return totalIntervals;
  }

  private calculateIntervalsBetweenTwoTimes(
    startTime: string,
    endTime: string
  ) {
    const startMinutes = this.stringToMinutes(startTime);
    const endMinutes = this.stringToMinutes(endTime);
    const totalMinutes = endMinutes - startMinutes;

    const intervals = totalMinutes / this.calendarConfig.minutesPerInterval;
    return intervals;
  }

  private calculateTimePlusIntevals(startTime: string, intervals: number) {
    const startTimeMinutes = this.stringToMinutes(startTime);
    const endTimeMinutes =
      startTimeMinutes + intervals * this.calendarConfig.minutesPerInterval;
    const endTime = this.minutesToTime(endTimeMinutes);
    return endTime;
  }

  private calculateDayTotalIntervals() {
    const startTimeMinutes = this.stringToMinutes(this.calendarConfig.dayStart);
    const endTimeMinutes = this.stringToMinutes(this.calendarConfig.dayEnd);
    const spanMinutes = endTimeMinutes - startTimeMinutes;
    const intervals = spanMinutes / this.calendarConfig.minutesPerInterval;
    const totalIntervals = Math.ceil(intervals);
    return totalIntervals;
  }

  private calculateDayPixelWidth() {
    const width =
      this.calculateDayTotalIntervals() * this.calendarConfig.intervalWidth;
    return width;
  }

  private cellXToMinutes(x: number) {
    return this.calendarConfig.minutesPerInterval * x;
  }

  private cellXToTime(x: number) {
    const minutes = this.cellXToMinutes(x);
    const minutesFromDayStart =
      this.stringToMinutes(this.calendarConfig.dayStart) + minutes;
    return this.minutesToTime(minutesFromDayStart);
  }

  private compareTime(time1: string, time2: string): number {
    const aMinutes = this.stringToMinutes(time1);
    const bMinutes = this.stringToMinutes(time2);

    const comparison = aMinutes === bMinutes ? 0 : aMinutes < bMinutes ? -1 : 1;

    return comparison;
  }

  private getYAxisWidth() {
    return parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        `--y-axis-width`
      ),
      10
    );
  }

  private stringToMinutes(time: string) {
    const a = time.split(':');
    const minutes = +a[0] * 60 + +a[1];
    return minutes;
  }

  private minutesToTime(minutes: number) {
    // checked, good
    // 6AM = 360
    // 6:45 = 360 + 45 (405)
    // 405 => "06:45"

    const hours = Math.floor(minutes / 60);
    let mins = `${minutes - hours * 60}`;

    if (mins === '0') {
      mins = '00';
    }

    const formatted = `${hours}:${mins}`.padStart(5, '0');
    return formatted;
  }

  private getDynamicProperty(variableName, integer = false) {
    const value = getComputedStyle(document.documentElement).getPropertyValue(
      `${variableName}`
    );

    return integer ? parseInt(value, 10) : value;
  }

  private isGoodDrag(targetCell): boolean {
    if (
      this.dragState.last &&
      (!(Math.abs(targetCell.x - this.dragState.last.x) <= 1) ||
        !(Math.abs(targetCell.y - this.dragState.last.y) <= 1))
    ) {
      return false;
    }
    this.dragState.last = targetCell;
    return true;
  }

  private isGoodViewportScroll(scrollX: number): boolean {
    if (
      this.viewportDragState.last &&
      !(Math.abs(scrollX - this.viewportDragState.last) <= 100)
    ) {
      console.warn(
        `Bad scroll! - scrollX: ${scrollX}, last: ${this.viewportDragState.last}`
      );

      return false;
    }

    this.viewportDragState.last = scrollX;
    return true;
  }
}
